import {ChangeEvent, useRef, useState} from "react";
import {Box} from "@material-ui/core";
import {EditOutlined} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import useStyles from './EditStampActionButtonStyles';
import {useAppDispatch} from "../../../../hooks/customReduxHooks";
import {setNewMedicPicture, setNewMedicStamp} from "../../../../store/medicProfileSlice";
import {IconButtonWithText} from "../../../index";
import MedicPictureCropModal from "../../medicPhoto/MedicPictureCropModal/MedicPictureCropModal";

const EditStampActionButton = () => {
    const classes = useStyles();
    const {t: commonT} = useTranslation(i18nNamespaces.COMMON);
    const dispatch = useAppDispatch();

    const inputFileRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File>(null);

    const pictureEditClickHandler = () => {
        inputFileRef.current.click();
    }

    const fileSelectedHandler = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFile(e.target.files[0]);
            setModalOpen(true);
        }
    }

    const closeModal = () => {
        setModalOpen(false);
        setSelectedFile(null);
    }

    const updateMedicStamp = async (imageFile: File) => {
        closeModal();
        await dispatch(setNewMedicStamp(imageFile));
    }

    return (
        <Box>
            <IconButtonWithText
                className={classes.iconButtonWithText}
                icon={
                    <EditOutlined
                        className={classes.editIcon}
                    />
                }
                label={commonT('change').toUpperCase()}
                onClick={pictureEditClickHandler}
            />
            {
                <input
                    type={'file'}
                    hidden
                    ref={inputFileRef}
                    onChange={fileSelectedHandler}
                    onClick={(event)=> {
                        // fix for not calling onChange, when the same file was selected two times in a row
                        (event.target as HTMLInputElement).value = null
                    }}
                />
            }
            {
                (modalOpen && selectedFile) && (
                    <MedicPictureCropModal
                        imageFile={selectedFile}
                        imageFileChanged={updateMedicStamp}
                        close={closeModal}
                        isRound={false}
                    />
                )
            }
        </Box>
    )
}

export default EditStampActionButton;